/**
 * Reading the answers of POST /rfp/auth/change-password.
 */

const DEFAULT_SUCCESS_MESSAGE = 'Your password was changed successfully.';

/** The server answers 200 with a message string; fixed text is used if it is empty. */
export const getChangePasswordSuccessMessage = (data) =>
    (typeof data === 'string' && data.trim()) || DEFAULT_SUCCESS_MESSAGE;

/** First readable message from a FastAPI-style 422 list, without the "Value error, " prefix. */
const firstValidationMessage = (detail) => {
    const message = Array.isArray(detail) ? detail[0]?.msg : '';
    return typeof message === 'string' ? message.replace(/^value error,\s*/i, '').trim() : '';
};

/**
 * A readable message for a failed change-password request.
 *   400 old password wrong, or new one same as the old one
 *   403 password not set yet (use set-password first)
 *   422 validation error
 */
export const describeChangePasswordError = (error) => {
    if (!error?.response) {
        return 'Cannot reach the server. Please check your connection and try again.';
    }

    const { status, data } = error.response;
    const detail = data?.detail;
    const serverMessage =
        (typeof detail === 'string' && detail.trim()) ||
        (typeof data?.message === 'string' && data.message.trim()) ||
        '';

    if (status === 400) {
        return serverMessage || 'Your current password is incorrect, or the new password is the same as the old one.';
    }
    if (status === 403) {
        return serverMessage || 'Your password has not been set yet. Please set it first using the link in your welcome email.';
    }
    if (status === 422) {
        return firstValidationMessage(detail) || 'Please check the passwords you entered and try again.';
    }
    if (status === 429) {
        return 'Too many attempts. Please wait a moment and try again.';
    }
    return serverMessage || 'The password could not be changed. Please try again.';
};
